import React, { useState, useEffect } from 'react';
import { Alert, Button, Spinner } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { getConfig, setConfig } from "../../services/AdminConfigService";

function DefaultResponsibleForm() {

    const [currentValue, setCurrentValue] = useState("");
    const [newValue, setNewValue] = useState("");
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);

    const handleCloseSuccess = () => {
        setShowSuccess(false);
    };

    const handleCloseError = () => setShowError(false);

    const handleShowSuccess = () => {
        setShowError(false);
        setShowSuccess(true);
    };

    const handleShowError = () => {
        setShowSuccess(false);
        setShowError(true);
    };

    useEffect(() => {
        getConfig('default_responsible_email')
            .then((data) => {
                setCurrentValue(data.config_value);
                setNewValue(data.config_value);
            })
            .catch(() => {
                handleShowError();
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSaving(true);
        try {
            const response = await setConfig('default_responsible_email', newValue);
            if (response.status === 200) {
                setCurrentValue(newValue);
                handleShowSuccess();
            } else {
                handleShowError();
            }
        } catch {
            handleShowError();
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return (
            <div className="container home text-center">
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Cargando...</span>
                </Spinner>
            </div>
        );
    }

    return (
        <div className="container home">
            <Alert variant="success" show={showSuccess} onClose={handleCloseSuccess} dismissible>
                <p>
                    Responsable por defecto actualizado correctamente.
                </p>
            </Alert>
            <Alert variant="danger" show={showError} onClose={handleCloseError} dismissible>
                <p>
                    Se ha producido un error.
                </p>
            </Alert>
            <h1 className="font-weight-light">Responsable por defecto</h1>
            <p className="text-muted">
                El responsable por defecto se asigna automáticamente a los nuevos usuarios.
            </p>
            <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="formResponsibleEmail">
                    <Form.Label>Email del responsable por defecto</Form.Label>
                    <Form.Control
                        required
                        type="email"
                        placeholder="Email"
                        value={newValue}
                        onChange={(e) => setNewValue(e.target.value)}
                    />
                    <Form.Text className="text-muted">
                        Valor actual: {currentValue}
                    </Form.Text>
                </Form.Group>

                <Button variant="primary" type="submit" disabled={saving}>
                    {saving ? 'Guardando...' : 'Guardar'}
                </Button>
            </Form>
        </div>
    );
}

export default DefaultResponsibleForm;
